module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-400-normal.woff2?c35e4c3958e209d17b319ad751c0cec2";